import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SystemControllerComponent } from './system-controller.component';
import { MdbGlobalModule } from 'src/app/shared/mdb-global.module';
import { DxAccordionModule, DxButtonModule, DxCheckBoxModule, DxDropDownBoxModule, DxFileUploaderModule, DxNumberBoxModule, DxPopupModule, DxRadioGroupModule, DxScrollViewModule, DxSelectBoxModule, DxTabPanelModule, DxTextBoxModule, DxTreeListModule, DxTreeViewModule } from 'devextreme-angular';



@NgModule({
  declarations: [
    SystemControllerComponent
  ],
  imports: [
    CommonModule,
    MdbGlobalModule,
    DxTextBoxModule,
    DxSelectBoxModule,
    DxPopupModule,
    DxScrollViewModule,
    DxTabPanelModule,
    DxCheckBoxModule,
    DxNumberBoxModule,
    DxFileUploaderModule,
    DxAccordionModule,
    DxButtonModule,
    DxDropDownBoxModule,
    DxTreeViewModule,
    DxRadioGroupModule,
    DxTreeListModule,
  ],
  exports: [
    SystemControllerComponent
  ]
})
export class SystemControllerModule { }
